export default __webpack_public_path__ + "static/media/pr.acd716ef.jpg";